import { createTheme } from "@mui/material";

const themeOptions = {
  palette: {
    mode: "light",
    common: {
      black: "#474747",
      white: "#ffffff",
    },
    background: {
      paper: "#ffffff",
      default: "#f8f8f8",
    },
    primary: {
      main: "#212528",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#e4e8e9",
      contrastText: "#212528",
    },
    error: {
      main: "#ff836d",
    },
    warning: {
      main: "#fad43b",
    },
    info: {
      main: "#1072f1",
    },
    success: {
      main: "#09d95b",
    },
    gray1: {
      main: "#caced8",
    },
    gray2: {
      main: "#e4e8e9",
    },
    gray3: {
      main: "#f5f5f5",
    },
  },
  typography: {
    fontFamily: 'Be Vietnam Pro, "Helvetica Neue", Arial, Roboto, sans-serif',
    fontSize: 12,
    htmlFontSize: 16,
    button: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: 1.75,
      letterSpacing: "0.00938em",
      textTransform: "inherit",
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderRadius: 8,
          },
          "&.MuiInputBase-root": {
            height: 44,
          },
          "& .MuiInputBase-input": {
            height: "100%",
            boxSizing: "border-box",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "transparent",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        },
      },
    },
  },
};

const theme = createTheme(themeOptions);

export default theme;
